<template>
  <v-container>

    <ViewsContainer
      :moduleName="moduleName"
      :listViewComponent="Table"
      :filterComponent="Filter"
      :data="data"
      :config="'@/components/listing/products/products.config'"
      :onCreate="create"
      :onUpdate="update"
      :onDelete="remove"
      :rowActionHandlers="rowActionHandlers"
      :show_toolbar="true"
      :show_pagination="true"
      :title="{singular:'Producto', plural:'Productos'}"
      :key="moduleName"
    />
    
  </v-container>
</template>

<script lang="ts" setup>
import { onMounted, ref, computed } from 'vue';
import { usePreferencesStore } from '@/store/preferences';
import { useProductsStore } from '@/store/products';
import { useModuleLayoutFetcher } from '@/composables/useModuleLayoutFetcher';
import { HEADERS, DEFAULT_HEADER_ORDER } from '@/components/listing/products/products.config';
import { useRoute } from 'vue-router';

import Table from '@/components/views/TableView.vue';
import MobileCardsView from '@/components/views/MobileCardsView.vue';
import Grid from '@/components/views/GridView.vue';
import Cards from '@/components/views/CardsView.vue';
import Filter from '@/components/drawer/Filters.vue';
import ViewsContainer from '@/components/views/ViewsContainer.vue'
import { CARD_FIELDS, DEFAULT_CARD_ORDER } from '@/components/modules/sales/sales.config';
import { useDisplay } from 'vuetify';

const { mobile } = useDisplay();
const isMobile = computed(() => mobile.value);

const route = useRoute();
const moduleName = 'Products'
const preferencesStore = usePreferencesStore();
const productsStore = useProductsStore();


const {
  create,
  update,
  remove,
} = useModuleLayoutFetcher(
  moduleName,
  (params) => productsStore.fetchProducts(params),
  {
    create: productsStore.createProduct,
    update: (data) => productsStore.updateProduct(data.id, data),
    remove: productsStore.deleteProduct,
  }
);

onMounted(() => {
  preferencesStore.currentModule = moduleName;
  // Registra los headers y defaults para ESTE módulo:
  preferencesStore.setAllModuleHeaders(moduleName, HEADERS);
  preferencesStore.setDefaultModuleHeaders(
    moduleName,
    DEFAULT_HEADER_ORDER
      .map(value => HEADERS.find(header => header.value === value))
      .filter(Boolean) as typeof HEADERS
  );
});

const rowActionHandlers = {
  
};

const data = computed(() => productsStore.products);

</script>
